import { shallowEqual, useSelector } from 'react-redux';

import type { RootState } from '../../../store';

export default function useTreatmentPlanV3TabPages() {
  const assessment = useSelector(
    (state: RootState) => ({
      page: state.treatmentPlanV3.assessmentPage,
      error: state.treatmentPlanV3.assessmentPageError,
      treatmentPlanId: state.treatmentPlanV3.assessmentPageTreatmentPlanId,
    }),
    shallowEqual,
  );
  const child = useSelector(
    (state: RootState) => ({
      page: state.treatmentPlanV3.childPage,
      error: state.treatmentPlanV3.childPageError,
      treatmentPlanId: state.treatmentPlanV3.childPageTreatmentPlanId,
    }),
    shallowEqual,
  );
  const crisis = useSelector(
    (state: RootState) => ({
      page: state.treatmentPlanV3.crisisPage,
      error: state.treatmentPlanV3.crisisPageError,
      treatmentPlanId: state.treatmentPlanV3.crisisPageTreatmentPlanId,
    }),
    shallowEqual,
  );
  const discharge = useSelector(
    (state: RootState) => ({
      page: state.treatmentPlanV3.dischargePage,
      error: state.treatmentPlanV3.dischargePageError,
      treatmentPlanId: state.treatmentPlanV3.dischargePageTreatmentPlanId,
    }),
    shallowEqual,
  );
  const education = useSelector(
    (state: RootState) => ({
      page: state.treatmentPlanV3.educationPage,
      error: state.treatmentPlanV3.educationPageError,
      treatmentPlanId: state.treatmentPlanV3.educationPageTreatmentPlanId,
    }),
    shallowEqual,
  );
  const family = useSelector(
    (state: RootState) => ({
      page: state.treatmentPlanV3.familyPage,
      error: state.treatmentPlanV3.familyPageError,
      treatmentPlanId: state.treatmentPlanV3.familyPageTreatmentPlanId,
    }),
    shallowEqual,
  );
  const medication = useSelector(
    (state: RootState) => ({
      page: state.treatmentPlanV3.medicationPage,
      error: state.treatmentPlanV3.medicationPageError,
      treatmentPlanId: state.treatmentPlanV3.medicationPageTreatmentPlanId,
    }),
    shallowEqual,
  );
  const referral = useSelector(
    (state: RootState) => ({
      page: state.treatmentPlanV3.referralPage,
      error: state.treatmentPlanV3.referralPageError,
      treatmentPlanId: state.treatmentPlanV3.referralPageTreatmentPlanId,
    }),
    shallowEqual,
  );
  const therapy = useSelector(
    (state: RootState) => ({
      page: state.treatmentPlanV3.therapyPage,
      error: state.treatmentPlanV3.therapyPageError,
      treatmentPlanId: state.treatmentPlanV3.therapyPageTreatmentPlanId,
    }),
    shallowEqual,
  );
  const treatment = useSelector(
    (state: RootState) => ({
      page: state.treatmentPlanV3.treatmentPage,
      error: state.treatmentPlanV3.treatmentPageError,
      treatmentPlanId: state.treatmentPlanV3.treatmentPageTreatmentPlanId,
    }),
    shallowEqual,
  );

  return {
    assessment,
    child,
    crisis,
    discharge,
    education,
    family,
    medication,
    referral,
    therapy,
    treatment,
  };
}
